export function CollectionIntro() {
  return (
    <section data-testid="books-collection-intro" className="relative overflow-hidden bg-[#FFFFFF] mt-[34px] md:mt-[30px]">
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-[11px] md:pt-[15px] pb-[27px] md:pb-[34px]">
        <div className="mx-auto text-center mb-[56px] reveal">
          <h2 className="max-w-2xl mx-auto font-display text-4xl md:text-5xl lg:text-6xl leading-[1.1] tracking-tight text-[#1C1917]">
            Books That Found Their Way Into the World.
          </h2>
          <div className="max-w-[806px] mx-auto mt-[16px] text-[20px] text-[#57534E] leading-relaxed space-y-4">
            <p>Some ideas arrive quietly.</p>
            <p>
              Others follow me around for years before I finally understand
              what they&rsquo;re asking me to say.
            </p>
            <p>These are the ones that insisted.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
